import { motion } from "framer-motion";
import { LOGO_URL } from "../constants";
import { useLang } from "../i18n";

export default function Preloader() {
  const { t } = useLang();
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-obsidian"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.img
        src={LOGO_URL}
        alt="III ROMA"
        className="h-32 w-32 rounded-full object-cover shadow-[0_0_60px_rgba(212,175,55,0.25)]"
        style={{ border: "1px solid rgba(212,175,55,0.5)" }}
        initial={{ opacity: 0, scale: 0.75 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.p
        className="text-carved-gold font-display mt-8 text-base tracking-[0.55em]"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.8 }}
      >
        III ROMA
      </motion.p>
      <div className="mt-6 h-px w-40 overflow-hidden bg-gold/15">
        <motion.div
          className="h-full bg-gold"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.4, duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
          style={{ transformOrigin: "left" }}
        />
      </div>
    </motion.div>
  );
}
